import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useApp } from "../../context/app";
import FlatList from 'flatlist-react';
import { Header } from "../../components/Header";
import { HeaderMobile } from "../../components/HeaderMobile";
import { api, urls } from "../../services/api";
import { TitlePage } from "../../components/TitlePage";
import { SearchMobile } from "../../components/SearchMobile";
import { ServicesAccordion } from "../../components/ServicesAccordion";
import { Banner } from "../../components/Banner";
import { MapSite } from "../../components/MapSite";
import { Footer } from "../../components/Footer";
import { IPublicacoes } from "../../interfaces/publicacoes";
import { ICategoria } from "../../interfaces/categoria";
import VLibras from '@djpfs/react-vlibras';
import { FolderIcon } from '../../components/icons/common/folder'
import { NewsShare } from "../../components/NewsShare";
import '../../assets/css/root.css';
import '../../assets/css/global.css';
import '../../assets/css/tema_escuro.css';
import './style.css';

export function CategoriaScreen() {
	
	let { id } = useParams();
	const { mobile, menuMobile, visible, configDomainURL } = useApp()
	const [categoria, setCategoria] = useState<ICategoria[]>([])
	const [publicacoes, setPublicacoes] = useState<IPublicacoes[]>([])
	const [titlePage, setTitlePage] = useState<string>('')

	useEffect(() => {

		(async () => {

			try {
				
				//console.log('Categoria')
				
				//console.log('id', id)

				const response = await api.get( urls.CategoriaDownload + id )
				//console.log('response.data', response.data)
				
				setCategoria( response.data )
				
			}
			catch (error) {
				console.log('Categoria Erro: ', error)
			}
			
		})()
		
	}, [])
	
	useEffect(() => {

		(async () => {

			try {
				
				const response2 = await api.get(urls.Publicacoes)
				//console.log('response2.data', response2.data)
				
				setPublicacoes( response2.data )
				
			}
			catch (error) {
				console.log('Categoria Erro: ', error)
			}
			
		})()
		
	}, [])
	
	useEffect(() => {

		//console.log( 'publicacoes', publicacoes ); 
		//console.log( 'id', id ); 
		
		publicacoes.map((item) => {
			
			//console.log( 'item.lista', item.lista )
			
			if( item.lista == Number(id) ){ 
			
				//console.log( 'item.titulo', item.titulo ) 
				setTitlePage( item.titulo )
				
			}
			
		})
		
	}, [publicacoes])
	
	const categoriaOrdenada = [...categoria].sort((a, b) =>
		a.titulo.localeCompare(b.titulo)
	);
	
	//console.log( 'publicacoes', publicacoes ); 
	//console.log( 'categoria', categoria ); 
	
	return (
		<div className="pages-Categoria">

			<>

				{

					menuMobile ?

						(

							<HeaderMobile />

						)

						:

						(

							<Header
								search
								route={` <a href="/publicacoes">Publicações</a> / ${titlePage}`}
							/>

						)
					
				}

				{

					mobile &&

					<SearchMobile />

				}

				{

					mobile &&

					<div className="pages-Categoria-mobile-separador" />
					
				}
				
				<TitlePage title={ titlePage } />

				<div className="pages-Categoria-container">
					
					{
						
						categoriaOrdenada.map((item) => (
							<div className="pages-Categoria-item">
								<a href={"/diretorio/"+ item.categoria}>
									<div className="pages-Categoria-icone"><FolderIcon /></div>
									<div className="pages-Categoria-nome">{item.titulo}</div>
								</a>
							</div>
						))
						
					}
					
				</div>
				
				<div className="pages-Article-container" style={{padding:'0vw'}}>
			
					<NewsShare />
					
				</div>

				<Banner mobile={mobile} />
				
				<div className="pages-Categoria-separador"></div>
				
				<MapSite />

				<Footer />

				{

					visible &&

					(

						<VLibras forceOnload />
						
					)
					
				}
				
			</>
			
		</div>
	)

}